import { render, staticRenderFns } from "./GroupTableBody.vue?vue&type=template&id=4e803a8d&"
import script from "./GroupTableBody.vue?vue&type=script&lang=js&"
export * from "./GroupTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports